var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.172,
    height: 28.478,
    viewBox: "0 0 28.172 28.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2530809_alarm_alarm_clock_clock_general_morning_alarm_icon",
    "data-name": "2530809_alarm_alarm clock_clock_general_morning alarm_icon",
    transform: "translate(-2.199 -1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(2.199 1.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M14.287,79.522a.813.813,0,0,1-.628-1.329l2.527-3.072a.813.813,0,0,1,1.255,1.033l-2.527,3.072A.811.811,0,0,1,14.287,79.522Z",
    transform: "translate(-9.827 -51.043)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M68.524,79.522a.811.811,0,0,1-.628-.3l-2.528-3.072a.813.813,0,0,1,1.255-1.033l2.528,3.072a.813.813,0,0,1-.627,1.329Z",
    transform: "translate(-44.809 -51.043)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M18.918,30.73A12.828,12.828,0,1,1,31.746,17.9,12.844,12.844,0,0,1,18.918,30.73Zm0-24.031a11.2,11.2,0,1,0,11.2,11.2A11.215,11.215,0,0,0,18.918,6.7Z",
    transform: "translate(-4.83 -3.854)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M47.7,24.923h-3.53a.813.813,0,0,1-.813-.813V15.065a.813.813,0,1,1,1.626,0V23.3H47.7a.813.813,0,1,1,0,1.625Z",
    transform: "translate(-30.041 -10.064)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M44.168,67.569a.813.813,0,0,1-.813-.813V64.75a.813.813,0,0,1,1.626,0v2.006A.813.813,0,0,1,44.168,67.569Z",
    transform: "translate(-30.042 -43.678)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M18.029,43.84H16.052a.813.813,0,1,1,0-1.626h1.977a.813.813,0,1,1,0,1.626Z",
    transform: "translate(-11.021 -28.981)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M67.911,43.84H65.934a.813.813,0,0,1,0-1.626h1.977a.813.813,0,1,1,0,1.626Z",
    transform: "translate(-44.768 -28.981)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M3.012,7.336A.813.813,0,0,1,2.2,6.523V4.795a3.493,3.493,0,0,1,3.49-3.488H7.416a.813.813,0,0,1,0,1.626H5.689A1.865,1.865,0,0,0,3.824,4.8V6.524A.812.812,0,0,1,3.012,7.336Z",
    transform: "translate(-2.199 -1.307)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M75.87,7.335a.813.813,0,0,1-.813-.813V4.794a1.865,1.865,0,0,0-1.864-1.863H71.466a.813.813,0,1,1,0-1.626h1.727a3.493,3.493,0,0,1,3.489,3.488V6.522A.812.812,0,0,1,75.87,7.335Z",
    transform: "translate(-48.51 -1.306)",
    fill: "#616161"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.34cfe47dd4d3eedb173be6302b271b18.svg";
export { ForwardRef as ReactComponent };